import Routes, {getHref} from '../../../routes'
import {stringifyId} from '../../../types'
import type {AgentPoolId} from '../../../types'

export const getQueueAllPoolsHref = (): string => getHref(Routes.QUEUE, {})
export const getQueuePoolHref = (agentPoolId?: AgentPoolId): string =>
  `${getHref(Routes.QUEUE, {})}?agentPoolId=${stringifyId(agentPoolId)}`
